module.exports = __webpack_public_path__ + "img/skiing001.ac2d5b6b.jpg";